import React, { useState, useEffect } from 'react';
import { X } from 'lucide-react';
import { Link } from 'react-router-dom';

const CookieConsent = () => {
  const [showConsent, setShowConsent] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('cookieConsent');
    if (!consent) {
      setShowConsent(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cookieConsent', 'accepted');
    setShowConsent(false);
  };

  const handleDecline = () => {
    localStorage.setItem('cookieConsent', 'declined');
    setShowConsent(false);
  };

  if (!showConsent) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 bg-zinc-900 border-t border-accent-900/20 p-4 z-50">
      <div className="max-w-7xl mx-auto flex flex-col md:flex-row items-center justify-between gap-4">
        <div className="flex-1">
          <p className="text-sm text-gray-300">
            Diese Website verwendet Cookies, um Ihnen die bestmögliche Nutzererfahrung zu bieten. 
            Weitere Informationen finden Sie in unserer{' '}
            <Link to="/privacy" className="text-accent-400 hover:text-accent-300 transition-colors">Datenschutzerklärung</Link>.
          </p>
        </div>
        <div className="flex gap-4">
          <button
            onClick={handleDecline}
            className="px-4 py-2 text-sm font-medium text-gray-300 hover:text-white transition-colors"
          >
            Ablehnen
          </button>
          <button
            onClick={handleAccept}
            className="px-4 py-2 text-sm font-medium bg-accent-600 text-white rounded hover:bg-accent-700 transition-colors"
          >
            Akzeptieren
          </button>
        </div>
        <button
          onClick={handleDecline}
          className="absolute top-2 right-2 md:hidden p-2"
          aria-label="Schließen"
        >
          <X size={20} />
        </button>
      </div>
    </div>
  );
};

export default CookieConsent;